<template>
  <div>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          출장종류
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ GET_APP_MAP_DATA.bizTripData.gntCdNm }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          출장기간
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{
            fetchPeriodText(
              GET_APP_MAP_DATA.bizTripData.sdate,
              GET_APP_MAP_DATA.bizTripData.edate,
            )
          }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          출장제목
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">
          {{ GET_APP_MAP_DATA.bizTripData.title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <div
      v-for="(col, index) in GET_APP_MAP_DATA.bizTripDynamicCols"
      :key="index"
    >
      <v-list-item two-line flat class="px-5">
        <v-list-item-content>
          <v-list-item-subtitle class="mb-1 app-label">
            {{ col.columnName }}
          </v-list-item-subtitle>
          <v-list-item-title class="app-desc">
            {{
              GET_APP_MAP_DATA.bizTripData[convCamelCase(col.columnId)] || ''
            }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
  </div>
</template>

<script>
/* 출장신청서 viewer > 상세내용 */
import viewerMixin from '@/mixins/viewerMixin.js';
import { convCamelCase as utilConvCamelCase } from '@/utils/util.js';
import dayjs from 'dayjs';

export default {
  mixins: [viewerMixin],

  props: {
    appInfoParam: Object,
  },
  data: () => ({
    dynamicCols: [], // 동적 컬럼 목록
    bizTripData: {}, // 신청서 입력결과값
  }),

  mounted() {
    this.fetchApplicationMap();
  },

  methods: {
    convCamelCase: utilConvCamelCase,

    fetchPeriodText(startDate, endDate) {
      const sYmd = dayjs(startDate).format('YYYY-MM-DD');
      const eYmd = dayjs(endDate).format('YYYY-MM-DD');

      // 요일 추출
      const sDay = dayjs(sYmd).format('ddd');
      const eDay = dayjs(eYmd).format('ddd');

      return `${sYmd}(${sDay})~${eYmd}(${eDay})`;
    },

    // 신청 상세 내용 조회
    async fetchApplicationMap() {
      try {
        this.ON_APP_SPINNER(); // 스피너 ON

        await this.$store.dispatch('ELA/FETCH_BIZ_TRIP_MAP', {
          searchApplSeq: this.appInfoParam.applSeq,
          searchApplSabun: this.appInfoParam.applSabun,
          searchApplYmd: this.appInfoParam.applYmd,
        });
        this.OFF_APP_SPINNER(); // 스피너 OFF
      } catch (error) {
        console.error('Error fetching application map:', error);
        this.OFF_APP_SPINNER(); // 스피너 OFF
      }
    },
  },
};
</script>

<style></style>
